import {
	ChangeDetectionStrategy,
	Component,
	Input,
	Output,
	OnInit,
	OnChanges,
	SimpleChanges,
	EventEmitter,
	ChangeDetectorRef,
	ViewChild
} from "@angular/core";

import {
	DatePickerComponent
} from "@progress/kendo-angular-dateinputs";
import {IDateRange} from "../date.range.picker/date.range.picker.interface";
import {HijriDateService} from "../../services/hijri.date.service";

@Component({
	selector:'cp-date-range-new-picker',
	templateUrl: './date.range.picker.new.template.html',
	styleUrls: ['./date.range.picker.new.style.scss'],
	changeDetection:ChangeDetectionStrategy.OnPush
})
export class DateRangePickerNewComponent implements OnInit, OnChanges {
	@Input() dateRange: IDateRange;
	@Input() rangeIsMandatory: boolean;
	@Input() disabled: boolean = false;
	@Input() showHijri: boolean;
	@Input() refresh: boolean;

	@Output() open: EventEmitter<any> = new EventEmitter<any>(false);
	@Output() close: EventEmitter<any> = new EventEmitter<any>(false);
	@Output() onChange: EventEmitter<IDateRange> = new EventEmitter<IDateRange>(false);
	@ViewChild('todatepicker', {static: false}) public toDatePicker: DatePickerComponent;

	public fromDate: Date;
	public toDate: Date;
	public validDateRange: boolean = false;

	constructor(private cd: ChangeDetectorRef,public hijriDateService: HijriDateService) {
	}

	public ngOnChanges(changes: SimpleChanges){
		if (changes["dateRange"]) {
			this.fromDate = this.dateRange?.from;
			this.toDate = this.dateRange?.to;
			this.dateRangeValidation();
		}
	}

	public ngOnInit(){
		this.fromDate = this.dateRange?.from;
		this.toDate = this.dateRange?.to;
	}

	public dateRangeValidation(){
		if (this.rangeIsMandatory) {
			this.validDateRange = this.fromDate && this.toDate && this.fromDate <= this.toDate;
		} else {
			if (this.fromDate && this.toDate) {
				this.validDateRange = this.fromDate <= this.toDate;
			} else {
				this.validDateRange = true;
			}
		}
		this.cd.detectChanges();
	}

	public handleSelectionFromChange($event: Date) {
		this.fromDate  = $event;
		if (!this.dateRange) {
			this.dateRange = {from: null, to: null};
		}
		this.dateRange.from = $event;
		this.handleSelectionRangeChange();
		this.onFromDatePickerClose();
	}

	public handleSelectionToChange($event: Date) {
		this.toDate  = $event;
		if (!this.dateRange) {
			this.dateRange = {from: null, to: null};
		}
		this.dateRange.to = $event;
		this.handleSelectionRangeChange();
	}

	// public HijriFormat(d: Date): string {
	// 	return d ? this.hijriDateService.getHijri(d) : ' ';
	// }

	private handleSelectionRangeChange() {
		this.dateRangeValidation();
		this.onChange.emit(this.dateRange);
	}

	private onFromDatePickerClose(){
		if (this.fromDate &&!this.toDate) {
			this.toDatePicker.toggle(true);
			this.toDatePicker.focus();
		}
	}
}

